var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.3988 48H13.5988C5.46455 48 0 42.2949 0 33.8023V14.2001C0 5.70747 5.46455 0 13.5988 0H34.4012C42.5355 0 48 5.70747 48 14.2001V33.8023C48 42.2949 42.5354 48 34.3988 48Z",
    fill: "#5570F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1881 16.0201C22.1881 19.3081 19.5121 21.9841 16.2241 21.9841C12.9337 21.9841 10.2601 19.3081 10.2601 16.0201C10.2601 12.7321 12.9337 10.0537 16.2241 10.0537C19.5121 10.0537 22.1881 12.7321 22.1881 16.0201ZM41.761 29.0104C42.3202 29.5528 42.721 30.172 42.985 30.832C43.7842 32.8288 43.369 35.2288 42.5146 37.2064C41.5018 39.5608 39.5626 41.3392 37.1194 42.1168C36.0346 42.4648 34.897 42.6136 33.7618 42.6136H13.6474C11.6458 42.6136 9.8746 42.148 8.4226 41.2744C7.513 40.7272 7.3522 39.4672 8.0266 38.6464C9.1546 37.2784 10.2682 35.9056 11.3914 34.5208C13.5322 31.8712 14.9746 31.1032 16.5778 31.7776C17.2282 32.056 17.881 32.476 18.553 32.9176C20.3434 34.1032 22.8322 35.7304 26.1106 33.964C28.3515 32.7386 29.6523 30.6418 30.7846 28.8167L30.8074 28.78C30.8836 28.6578 30.9591 28.5358 31.0344 28.414C31.4194 27.7919 31.7986 27.1792 32.2282 26.6152C32.761 25.9168 34.7386 23.7328 37.2946 25.288C38.9242 26.2672 40.2946 27.592 41.761 29.0104Z",
    fill: "#5570F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.68e7f1b7ff733cebff2b4f2894983ac3.svg";
export { ForwardRef as ReactComponent };